import { render, staticRenderFns } from "./PerimeterSearch.vue?vue&type=template&id=2db957b0"
import script from "./PerimeterSearch.vue?vue&type=script&lang=js"
export * from "./PerimeterSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports